<template>
    <div class="product-pricing" :class="[`justify_${contentPosition}`]">
        <div v-if="discountCode" class="product-pricing-discount">
            <Icon type="Offer" class="product-pricing-discount-icon" size="xs" />
            <span class="product-pricing-discount-label">
                <Translation :translate="{ key: 'shared.with_code', suffix: ' ' }" />
                <strong>{{ discountCode }}</strong>
            </span>
        </div>

        <div class="product-pricing-prices">
            <Translation
                class="product-pricing-prices-label"
                :translate="{ key: 'shared.price' }" />
            <span v-if="oldPrice" class="product-pricing-prices-strikethrough">
                {{ getFormattedPrice(oldPrice) }}
            </span>
            <span class="product-pricing-prices-price" :class="{ discounted: oldPrice }">
                {{ getFormattedPrice(price) }}
            </span>
        </div>
    </div>
</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';
    import { getMoneyObjectAsString } from '@shared/helpers/money';
    import { Money } from '@libs/money/money.interfaces';
    import { ContentPosition } from '@ui/components/ProductPricing/ProductPricing.interfaces';
    import Translation from '@ui/components/Translation/Translation.vue';
    import Icon from '@ui/components/Icon/Icon.vue';

    export default defineComponent({
        name: 'ProductPricing',
        methods: { getMoneyObjectAsString },
        components: { Translation, Icon },
        props: {
            price: {
                type: Object as PropType<Money>,
                required: true,
            },
            oldPrice: {
                type: Object as PropType<Money>,
            },
            discountCode: {
                type: String,
            },
            contentPosition: {
                type: String as PropType<ContentPosition>,
                default: 'end',
            },
        },
        setup() {
            const getFormattedPrice = (money: Money | undefined) => {
                if (!money) return;

                return money.Amount < 0
                    ? `- ${getMoneyObjectAsString(money)}`
                    : getMoneyObjectAsString(money);
            };

            return {
                getFormattedPrice,
            };
        },
    });
</script>

<style lang="scss" scoped>
    @forward 'ProductPricing';
</style>
